'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _ramda = require('ramda');
var _reduxConnect = require('redux-connect');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _services = require('../../services');

var _components = require('../../components');

var _propertyDetails = require('../../redux/modules/propertyDetails');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Redux


// Helpers
var
PropertyDetailsNative = function (_Component) {_inherits(PropertyDetailsNative, _Component);
  function PropertyDetailsNative(props) {_classCallCheck(this, PropertyDetailsNative);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));
    _this.state = {
      propertyType: props.propertyDetails.data ?
      _this.formatPropertyTypes(props.propertyDetails.data.property_type) : '' };return _this;

  }PropertyDetailsNative.prototype.

  componentWillMount = function componentWillMount() {
    if (!this.props.propertyDetails.data) {
      this.props.receiveProperty({ id: this.props.params.id });
    }
  };PropertyDetailsNative.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(_ref) {var propertyDetails = _ref.propertyDetails,locale = _ref.locale;
    if (
    !this.state.propertyType && propertyDetails.data ||
    propertyDetails && propertyDetails.data && this.state.locale !== locale)
    {
      this.setState({ propertyType: this.formatPropertyTypes(propertyDetails.data.property_type) });
    }
  };PropertyDetailsNative.prototype.

  formatPropertyTypes = function formatPropertyTypes(propertyType) {
    return this.props.translate('propertyTypes', propertyType)();
  };PropertyDetailsNative.prototype.

  render = function render() {
    var data = this.props.propertyDetails.data;var _props$propertyDetail =
    this.props.propertyDetails,isLightboxOpen = _props$propertyDetail.isLightboxOpen,currentImage = _props$propertyDetail.currentImage,isModalContactsOpen = _props$propertyDetail.isModalContactsOpen,isModalShareOpen = _props$propertyDetail.isModalShareOpen;

    return (
      _react2.default.createElement(_components.PropertyDetails, {
        className: 'pageDetails',
        propertyData: Object.assign({},
        data, {
          property_type: this.state.propertyType }),

        isModal: false,
        translate: this.props.translate('propertyDetails'),
        locale: this.props.locale,
        currentImage: currentImage,
        openLightbox: this.props.openLightbox,
        hideLightbox: this.props.hideLightbox,
        isLightboxOpen: isLightboxOpen,
        isMobile: this.props.isMobile,
        openModalContacts: this.props.openModalContacts,
        hideModalContacts: this.props.hideModalContacts,
        isModalContactsOpen: isModalContactsOpen,
        openModalShare: this.props.openModalShare,
        hideModalShare: this.props.hideModalShare,
        incrementClicks: _services.AnalyticsEventService.createPropertyEvent,
        isModalShareOpen: isModalShareOpen,
        screenWidth: this.props.screenWidth }));


  };return PropertyDetailsNative;}(_react.Component);


PropertyDetailsNative.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  propertyDetails: _propTypes2.default.object,
  receiveProperty: _propTypes2.default.func,
  openLightbox: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  params: _propTypes2.default.object,
  openModalContacts: _propTypes2.default.func,
  hideModalContacts: _propTypes2.default.func,
  openModalShare: _propTypes2.default.func,
  hideModalShare: _propTypes2.default.func,
  screenWidth: _propTypes2.default.number };



var fetchData = function fetchData(_ref2) {var store = _ref2.store,params = _ref2.params;return Promise.resolve(store.dispatch((0, _propertyDetails.receiveProperty)({ id: params.id })));};

var mapStateToProps = function mapStateToProps(_ref3) {var
  lang = _ref3.lang,
  propertyDetails = _ref3.propertyDetails,
  windowDimentions = _ref3.windowDimentions;return (
    {
      translate: (0, _reduxPagan.getLang)(lang, 'static'),
      propertyDetails: propertyDetails,
      screenWidth: windowDimentions.width });};


var mapDispatchToProps = {
  openLightbox: _propertyDetails.openLightbox,
  hideLightbox: _propertyDetails.hideLightbox,
  receiveProperty: _propertyDetails.receiveProperty,
  openModalContacts: _propertyDetails.openModalContacts,
  hideModalContacts: _propertyDetails.hideModalContacts,
  openModalShare: _propertyDetails.openModalShare,
  hideModalShare: _propertyDetails.hideModalShare };exports.default =


(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)([{ key: 'Property', promise: fetchData }]),
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
PropertyDetailsNative);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/PropertyDetailsNative/PropertyDetailsNative.js
// module id = 3060
// module chunks = 0